import { citationLocationLabel } from '@/components/Citations/citationLabel'

/** Dedupe web citation hosts into pill labels for research/findings steps. */
export function sourcePillsFromCitations(citations = []) {
  const labels = []
  const seen = new Set()
  citations.forEach((citation) => {
    if (citation?.kind !== 'web') return
    const label = citationLocationLabel(citation)
    if (!label || seen.has(label)) return
    seen.add(label)
    labels.push(label)
  })
  return labels
}
